import http from 'lc-http';

export const post = (url, body) => {
  const promise = http.post(url, body)
    .then(({ data }) => {
      if (data.redirectURL) {
        const currentURL = new URL(window.location.href);
        window.location.href = `${currentURL.origin}${data.redirectURL}`;
        return { capAlreadyReview: true };
      }
      return data;
    })
    .catch(error => {
      throw error;
    });

  return promise;
}
